import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-65af45f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "operat-button-box" }
const _hoisted_2 = { class: "userinfo-box" }
const _hoisted_3 = { style: {"color":"red"} }
const _hoisted_4 = { class: "price-row-list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_button = _resolveComponent("ui-button")!
  const _component_ui_switch = _resolveComponent("ui-switch")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_ui_table = _resolveComponent("ui-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_ui_button, {
        style: {"margin-right":"10px"},
        onClick: _ctx.editInfo
      }, {
        default: _withCtx(() => [
          _createTextVNode("编辑付费会员")
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createTextVNode(" 招募会员： "),
      _createVNode(_component_ui_switch, {
        "false-value": 0,
        modelValue: _ctx.store.payVipSwitch,
        "onUpdate:modelValue": _ctx.changeVip,
        "true-value": 1
      }, {
        default: _withCtx(() => [
          _createElementVNode("template", null, [
            _createTextVNode(_toDisplayString(_ctx.store.payVipSwitch ? '开启' : '关闭'), 1)
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "onUpdate:modelValue"])
    ]),
    _createVNode(_component_ui_table, { data: _ctx.list }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "会员级别",
          width: "130"
        }, {
          default: _withCtx(({ row, $index }) => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("span", _hoisted_3, "VIP" + _toDisplayString($index + 1), 1)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "名称",
          width: "140"
        }, {
          default: _withCtx(({ row }) => [
            _createElementVNode("div", null, _toDisplayString(row.name || "-"), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "价格",
          width: "160"
        }, {
          default: _withCtx(({ row }) => [
            _createElementVNode("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.priceList, (item, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: i,
                  class: "price-item-box"
                }, [
                  _createElementVNode("div", null, _toDisplayString(item.name), 1),
                  _createElementVNode("div", null, _toDisplayString(item.price), 1)
                ]))
              }), 128))
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { label: "会员人数" }, {
          default: _withCtx(({ row }) => [
            _createElementVNode("span", null, _toDisplayString(row.userCount || 0), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"])
  ]))
}